import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import 'abortcontroller-polyfill/dist/polyfill-patch-fetch'

import './i18n/i18n'

import React, { Suspense } from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'

import App from './App'
import createStore from './createStore'

ReactDOM.render(
  <React.StrictMode>
    <Suspense fallback={null}>
      <Provider store={createStore()}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Provider>
    </Suspense>
  </React.StrictMode>,
  document.getElementById('root')
)
